module.exports = "/_next/static/images/osp-e5250837c09ecf04ac015ca004565ac1.png.webp";